export function WorkspaceNewButton({ onClick, label = "New" }: { onClick: () => void; label?: string }) {
  return (
    <button type="button" className="workspace-new-btn" onClick={onClick}>
      {label}
    </button>
  );
}
